import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Container,
  Icon,
} from 'semantic-ui-react';

const SnukTableAddButton = (props) => {
  const {
    iconName, label, isModalOpen, openModalAction, containerElem: ContainerElem,
  } = props;

  return (
    <Container fluid>
      <Button icon labelPosition="left" primary floated="right" onClick={openModalAction}>
        <Icon name={iconName} /> {label}
      </Button>
      {isModalOpen && <ContainerElem />}
    </Container>
  );
};

SnukTableAddButton.propTypes = {
  iconName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  isModalOpen: PropTypes.bool.isRequired,
  openModalAction: PropTypes.func.isRequired,
  containerElem: PropTypes.func.isRequired,
};

export default SnukTableAddButton;



// WEBPACK FOOTER //
// ./src/components/reusable/SnukTable/SnukTableAddButton.js